import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const NotFound = () => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <div className="min-h-[80vh] flex items-center px-6 md:px-12 lg:px-24" data-testid="not-found-page">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-2xl"
      >
        <span className="caption text-muted-foreground block mb-6">
          {isArabic ? 'خطأ 404' : 'ERROR 404'}
        </span>
        
        <h1 className="heading-display mb-8" style={{ fontSize: 'clamp(3rem, 8vw, 6rem)' }}>
          {isArabic ? 'الصفحة غير موجودة.' : 'Page not found.'}
        </h1>
        
        <p className="body-large text-muted-foreground mb-12 max-w-lg">
          {isArabic 
            ? 'يبدو أن هذا الأرشيف لم يُشكَّل بعد — أو ربما أُزيل من المجموعة.'
            : 'This archive hasn\'t been formed yet — or perhaps it\'s been removed from the collection.'}
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <Link 
            to="/" 
            className="caption link-subtle inline-flex items-center gap-2"
            data-testid="404-home-link"
          >
            <ArrowLeft size={14} className={isArabic ? 'rotate-180' : ''} />
            {isArabic ? 'العودة إلى الرئيسية' : 'Return home'}
          </Link>
          <Link 
            to="/notes" 
            className="caption link-subtle inline-flex items-center gap-2"
            data-testid="404-notes-link"
          >
            <ArrowLeft size={14} className={isArabic ? 'rotate-180' : ''} />
            {isArabic ? 'تصفّح الديوان' : 'Browse the reading room'}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
